// test1818
(1818 && 0);
